import moment from "moment";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import { useDispatch, useSelector } from "react-redux";
import { CloseIcon } from "../../../assets/icons";
import Input from "../../../utils/components/Input/Input";
import useModal from "../../../utils/hooks/useModal";
import { getAdminCampaignById, updateAdminCampaign } from "../../actions/adminCampaignsActions";
import { seeListActionAward } from "../../actions/awardsActions";
const EditAdminCampaigns = ({ history, match }) => {
  const [dateStart, setDateStart] = useState(new Date());
  const [dateEnd, setDateEnd] = useState(new Date());
  const [refCalendarStart, isVisibleCalendarStart, setIsVisibleCalendarStart] = useModal(false);
  const [refCalendarEnd, isVisibleCalendarEnd, setIsVisibleCalendarEnd] = useModal(false);
  const [dateView, setDateView] = useState("");
  const [dateViewEnd, setDateViewEnd] = useState("");
  const givePointsBy = [];
  const [pointsOptions, setPointsOptions] = useState([]);
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [timeStart, setTimeStart] = useState('')
  const [timeEnd, setTimeEnd] = useState('')
  const [multimedia, setMultimedia] = useState(null)
  const [isValidate, setValidate] = useState(false)
  const [error, setError] = useState({})
  const { getCampaignById } = useSelector((state) => state.adminCampaignsList);

  let idCampaing = match.params.idCampaign

  var dateObj = new Date();
  var month = dateObj.getUTCMonth() + 1;
  var day = dateObj.getUTCDate();
  var year = dateObj.getUTCFullYear();
  var maxDateCalendar = new Date(year - 13, month, day);

  //convert hours
  console.log();
  const initHour = new Date(getCampaignById.initDate).toTimeString('en-US').split(' ')[0]
  const endHour = new Date(getCampaignById.endDate).toTimeString('en-US').split(' ')[0]


  const initDate = new Date(getCampaignById.initDate).toLocaleDateString()
  const endDate = new Date(getCampaignById.endDate).toLocaleDateString()

  const onChange = (dateTime) => {
    const saveDate = new Date(dateTime);
    setDateView(
      saveDate.getDate() +
      "/" +
      (saveDate.getMonth() + 1) +
      "/" +
      saveDate.getFullYear()
    );

    setDateStart(dateTime);

    setIsVisibleCalendarStart(false);

    console.log();
  };
  const onChangeEnd = (dateTime) => {
    const saveDate = new Date(dateTime);
    setDateViewEnd(
      saveDate.getDate() +
      "/" +
      (saveDate.getMonth() + 1) +
      "/" +
      saveDate.getFullYear()
    );

    setDateEnd(dateTime);
    setIsVisibleCalendarEnd(false);
    console.log();
  };
  const handleSelectConcept = (e) => {
    var code = e.target.value;
    setPointsOptions(prevOptions => {
      if (prevOptions.find(option => option.code ===code) === undefined) {
        return [
          ...prevOptions,
          {
            code: code,
            value: 1,
            ecos : 1,
            description: listActionAwards.find(option => option.actionCode ===code).name
          }
        ]
      } else {
        return prevOptions
      }
    })
  }

  const { listActionAwards } = useSelector(state => state.awardsAdmin)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(seeListActionAward())
    dispatch(getAdminCampaignById(idCampaing))
  }, [])

  useEffect(() => {

    setName(getCampaignById.name)
    setDescription(getCampaignById.description)
    setTimeStart(initHour)
    setTimeEnd(endHour)
    setDateView(initDate)
    setDateViewEnd(endDate)
    if (getCampaignById.systemActions && listActionAwards.length > 0 && pointsOptions.length===0) {
      getCampaignById.systemActions.map((action) => {
        setPointsOptions(prevOptions => {
          return [
            ...prevOptions,
            {
              code: action.actionCode,
              value: action.points,
             ecos: action.ecos,
              description: listActionAwards.find(option => option.actionCode ===action.actionCode).name
            }
          ]
        })
      })
    }
  }, [getCampaignById, listActionAwards])

  const isFocused = (e) => {
    const { name } = e.target;
    setError(prevError => ({
      ...prevError,
      [name]: ''
    }));
  }

  return (
    <div>
      <div className="container">
        <div className="content-header">
          <h2>
            <strong>Administra</strong> tu campaña
          </h2>
          <label>Nombre</label>
          <input type="text" placeholder="Nombre de Campaña" onChange={
            (e) => { setName(e.target.value) }
          }
            value={name}
            className="input-admin-points"
          />
          <label>
            <input type="file" onChange={(event) => {
              if (event.target.files[0] && event.target.files[0].type.includes('image')) {
                setMultimedia(event.target.files[0])
              }
            }} />
            <div className="div-style-button">Subir Contenido</div>
          </label>
          <input type="text" placeholder="Descripción" onChange={
            (e) => { setDescription(e.target.value) }
          }
            value={description}
            className="input-admin-points"
          />
        </div>

        <select
          className="input-admin-points"
          name="pointsOptions"
          id="pointsOptions"
          onChange={(e) => {
            handleSelectConcept(e)
          }}
        >
          {
            listActionAwards.map((action) => (
              <option value={action.actionCode} key={action._id}>{action.name}</option>
            ))
          }

        </select>
        <div>
          {
            pointsOptions.map((action) => (
              <div className="column centerItems" key={action.code}>
              <label> Por "{action.description}" se ganan</label>
              <Input
                onChange={(e) => {
                  const v = e.target.value
                  setPointsOptions((prevOptions) => {
                    const options = prevOptions.map(option => {
                      if (option.code === action.code) {
                        option.value = v
                      }
                      return option
                    })
                    return options
                  })
                }}
                value={action.value}
                name={action.code}
              />
              Puntos de ranking
              <Input
                onChange={(e) => {
                  const v = e.target.value
                  setPointsOptions((prevOptions) => {
                    const options = prevOptions.map(option => {
                      if (option.code === action.code) {
                        option.ecos = v
                      }
                      return option
                    })
                    return options
                  })
                }}
                value={action.ecos}
                name={action.code}
              />
              Ecos
              <div className="ml-2"
                onClick={() => {
                  setPointsOptions(prevOptions => {
                    const options = prevOptions.filter(option => option.code !== action.code)
                    return options
                  })
                }}
              >
                <CloseIcon height={25} />
              </div>
            </div>
              
            ))
          }
        </div>
        <div className="container-footer" ref={node => {
          refCalendarStart.current = node
          refCalendarEnd.current = node
        }}>
          <div className="container-dates">
            <p>Fecha de Inicio</p>
            <input
              className="input-class-register dates-style"
              type="text"
              placeholder={'Fecha de Inicio'}
              value={dateView}
              onClick={() => setIsVisibleCalendarStart(true)}
              autoComplete="off"
            />
            {isVisibleCalendarStart ? (
              <div className="calendar-register">
                <Calendar
                  onChange={(dateTime) => onChange(dateTime)}
                  value={dateStart}
                />
              </div>
            ) : (
              <div></div>
            )}
            <input type="time" onChange={
              (e) => { setTimeStart(e.target.value) }
            } value={timeStart}
              className="hours-style"
            />
          </div>
          <div className="container-dates">
            <p>Fecha de Finalización</p>
            <input
              className="input-class-register dates-style"
              type="text"
              placeholder={'Fecha de Finalización'}
              value={dateViewEnd}
              onClick={() => setIsVisibleCalendarEnd(true)}
              autoComplete="off"
            />
            {isVisibleCalendarEnd ? (
              <div className="calendar-register">
                <Calendar
                  onChange={(dateTime) => onChangeEnd(dateTime)}
                  value={dateEnd}
                />
              </div>
            ) : (
              <div></div>
            )}
            <input type="time" onChange={
              (e) => { setTimeEnd(e.target.value) }
            } value={timeEnd}
              className="hours-style"
            />
          </div>
        </div>
        <div className="list-option-points">
          {
            givePointsBy.map((element) => {
              return <p>{element}</p>
            })
          }
        </div>
        <div className="container-button">
          <button className='button-card-campaign'
            onClick={() => {
              const systemActions = pointsOptions.map((option) => {
                return {
                  actionCode: option.code,
                  points: parseInt(option.value),
                  ecos: parseInt(option.ecos),
                }
              })
              const initDate = moment(dateView + ' ' + timeStart, 'DD/MM/YYYY HH:mm').toISOString()
              const endDate = moment(dateViewEnd + ' ' + timeEnd, 'DD/MM/YYYY HH:mm').toISOString()
              const formData = new FormData()

              formData.append('campaignID', idCampaing)
              formData.append('name', name)
              formData.append('description', description)
              formData.append('initDate', initDate)
              formData.append('endDate', endDate)
              formData.append('systemActions', JSON.stringify(systemActions))
              if (multimedia) {
                formData.append('multimedia', multimedia)
              }
              dispatch(updateAdminCampaign(formData, history))

            }
            }>Guardar</button>
        </div>
      </div>
    </div>
  );
};

export default EditAdminCampaigns;
